module.exports = __webpack_public_path__ + "img/icon_twitter.8a6839db9556e875a372c59691be62d4.svg";